import { className } from '@empori/util';
import * as React from 'react';
export function FilterOptions(props) {
    var _a = React.useState(false), toggled = _a[0], toggle = _a[1];
    var container = React.useRef(null);
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (container.current && !container.current.contains(event.target)) {
                toggle(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [container]);
    return (React.createElement("div", { ref: container, className: 'filter-container element-flex' },
        React.createElement("div", { className: className('filter-toggler', { toggled: toggled }), onClick: function () { return toggle(!toggled); } },
            React.createElement("i", { className: 'fa-regular fa-filter' }),
            React.createElement("span", null, "Filter (".concat(props.itemCount, ")"))),
        React.createElement("div", { className: className('filter-options', { toggled: toggled }) },
            React.createElement(MultiSelectOption, { selection: props.tags, activeSelection: props.activeTags, select: props.setTag }))));
}
function MultiSelectOption(props) {
    return (React.createElement("div", { className: 'multi-select-option filter-option' }, props.selection.map(function (option) {
        return React.createElement("div", { key: option, className: className('option', { selected: props.activeSelection.includes(option) }), onClick: function () { return props.select(option); } }, option);
    })));
}
export function Search(props) {
    return (React.createElement("div", { className: 'search-container' },
        React.createElement("i", { className: 'fa-regular fa-magnifying-glass' }),
        React.createElement("input", { placeholder: 'S\u00F6k', type: 'text', value: props.term, onChange: function (e) { return props.setTerm(e.currentTarget.value); } })));
}
